import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PasswordComponent } from './password.component';
import { PasswordRoutingModule } from './password-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PasswordRoutingModule
   // RouterModule.forChild(routes)
  ],
  declarations: [
    PasswordComponent
  ]
})
export class  PasswordModule { }